import { getCookiePreferences, CookiePreferenceId } from '../cookiePreferences'

export const updateDynamicYieldCookieConsent = async (): Promise<void> => {
  const isAccepted = getCookiePreferences()?.[CookiePreferenceId.MarketingAdvertising] ?? false
  window.DY = window.DY || {}
  window.DY.userActiveConsent = { accepted: isAccepted }
  window.DYO?.ActiveConsent?.updateConsentAcceptedStatus(isAccepted)
}
